/* src/app/builder-screen-beta/smart-suggestions-panel/smart-suggestions-panel.component.scss */
.smart-suggestions-panel {
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}
.smart-suggestions-panel.compact {
  margin-bottom: 8px;
}
.smart-suggestions-panel .suggestions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background:
    linear-gradient(
      135deg,
      #fff7e6 0%,
      #fff2d9 100%);
  border-bottom: 1px solid #ffe7ba;
}
.smart-suggestions-panel .suggestions-header .header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.smart-suggestions-panel .suggestions-header .header-content .suggestions-icon {
  color: #faad14;
  font-size: 16px;
}
.smart-suggestions-panel .suggestions-header .header-content .suggestions-title {
  font-weight: 600;
  color: #262626;
  font-size: 13px;
}
.smart-suggestions-panel .suggestions-header .header-actions {
  display: flex;
  gap: 4px;
}
.smart-suggestions-panel .suggestions-header .header-actions button {
  border: none;
  box-shadow: none;
}
.smart-suggestions-panel .suggestions-header .header-actions button:hover {
  background: rgba(250, 173, 20, 0.1);
}
.smart-suggestions-panel .suggestions-list {
  max-height: 300px;
  overflow-y: auto;
  padding: 8px;
}
.smart-suggestions-panel .suggestions-list .suggestion-item {
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  margin-bottom: 8px;
  overflow: hidden;
  transition: all 0.2s ease;
  position: relative;
}
.smart-suggestions-panel .suggestions-list .suggestion-item:last-child {
  margin-bottom: 0;
}
.smart-suggestions-panel .suggestions-list .suggestion-item:hover {
  border-color: #d9d9d9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.smart-suggestions-panel .suggestions-list .suggestion-item.high-confidence {
  border-left: 4px solid #52c41a;
}
.smart-suggestions-panel .suggestions-list .suggestion-item.medium-confidence {
  border-left: 4px solid #faad14;
}
.smart-suggestions-panel .suggestions-list .suggestion-item.low-confidence {
  border-left: 4px solid #1890ff;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-main {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-main .suggestion-action-icon {
  font-size: 16px;
  margin-top: 2px;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-main .suggestion-text {
  flex: 1;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-main .suggestion-text .suggestion-reason {
  font-size: 13px;
  color: #262626;
  font-weight: 500;
  margin-bottom: 6px;
  line-height: 1.4;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-main .suggestion-text .suggestion-details {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-main .suggestion-text .suggestion-details .panel-name {
  font-size: 11px;
  color: #8c8c8c;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-actions .apply-btn {
  background: #52c41a;
  border-color: #52c41a;
  color: white;
  font-size: 12px;
  height: 28px;
  padding: 0 8px;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-actions .apply-btn:hover {
  background: #73d13d;
  border-color: #73d13d;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-actions .dismiss-btn {
  color: #8c8c8c;
  border: none;
  height: 28px;
  width: 28px;
  padding: 0;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .suggestion-content .suggestion-actions .dismiss-btn:hover {
  background: #f5f5f5;
  color: #595959;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .confidence-indicator {
  height: 3px;
  background: #f0f0f0;
  position: relative;
}
.smart-suggestions-panel .suggestions-list .suggestion-item .confidence-indicator .confidence-bar {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 0 0 6px 6px;
}
.smart-suggestions-panel .suggestions-empty {
  padding: 20px;
  text-align: center;
}
.smart-suggestions-panel .suggestions-empty .ant-empty {
  margin: 0;
}
.smart-suggestions-panel.compact .suggestions-header {
  padding: 8px 12px;
}
.smart-suggestions-panel.compact .suggestions-header .suggestions-title {
  font-size: 12px;
}
.smart-suggestions-panel.compact .suggestions-list {
  max-height: 200px;
  padding: 6px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item {
  margin-bottom: 6px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content {
  padding: 8px;
  gap: 8px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content .suggestion-main {
  gap: 8px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content .suggestion-main .suggestion-text .suggestion-reason {
  font-size: 12px;
  margin-bottom: 4px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content .suggestion-main .suggestion-text .suggestion-details {
  gap: 6px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content .suggestion-main .suggestion-text .suggestion-details .panel-name {
  font-size: 10px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content .suggestion-actions {
  gap: 4px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content .suggestion-actions .apply-btn {
  height: 24px;
  font-size: 11px;
  padding: 0 6px;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content .suggestion-actions .apply-btn span {
  display: none;
}
.smart-suggestions-panel.compact .suggestions-list .suggestion-item .suggestion-content .suggestion-actions .dismiss-btn {
  height: 24px;
  width: 24px;
}
.smart-suggestions-panel.compact .suggestions-empty {
  padding: 16px;
}
.smart-suggestions-panel .suggestion-item {
  animation: slideIn 0.3s ease-out;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.smart-suggestions-panel .suggestions-list::-webkit-scrollbar {
  width: 6px;
}
.smart-suggestions-panel .suggestions-list::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}
.smart-suggestions-panel .suggestions-list::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}
.smart-suggestions-panel .suggestions-list::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
/*# sourceMappingURL=smart-suggestions-panel.component.css.map */
